import styled from "styled-components";
import { getColor } from "~/helpers/style";

export const RadioButtonContainer = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const HiddenRadioButton = styled.input.attrs({ type: "radio" })`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`;

export const StyledRadioButton = styled.div`
  display: inline-flex;
  width: 11px;
  height: 11px;
  border: 1px solid ${getColor("borderSecondary")};
  transition: border 0.2s;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  margin-right: 5px;

  &::after {
    content: "";
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: ${getColor("primary")};
    opacity: 0;
    transition: opacity 0.2s;
  }

  ${HiddenRadioButton}:checked + &::after {
    opacity: 1;
  }
  ${HiddenRadioButton}:checked + & {
    border: 1px solid ${getColor("primary")};
  }
`;
